import { IonButton, IonContent } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PRIVACY_LINK, TERMS_LINK } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import { OnboardingScreenSecurityStyles } from './Security.styles';

export const OnboardingScreenSecurity: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Security',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  return (
    <OnboardingScreenSecurityStyles>
      <IonContent scrollY={false}>
        <div className="description">
          <OnboardingTitle>
            What happens in Dialogue, stays in Dialogue
          </OnboardingTitle>
          <OnboardingSubtitle>
            Dialogue prioritizes and protects your personal information
          </OnboardingSubtitle>
        </div>

        <Player
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/lock-animation-dark.json"
          autoplay
          loop={false}
          keepLastFrame
          className="animation"
        />

        <UiTypography className="disclaimer" variant="body-small">
          We never disclose your information. By tapping on Continue, you agree
          with our
          <IonButton
            mode="ios"
            className="link"
            href={PRIVACY_LINK}
            target="_blank"
          >
            Privacy Policy
          </IonButton>{' '}
          and
          <IonButton
            mode="ios"
            className="link"
            href={TERMS_LINK}
            target="_blank"
          >
            Terms of Use
          </IonButton>
        </UiTypography>
      </IonContent>
      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingScreenSecurityStyles>
  );
};
